import React from 'react';
import ContentLayout from 'components/ContentLayout';

function Products() {
  return (
    <ContentLayout>
      <h1>Products</h1>
    </ContentLayout>
  );
}

export default Products;
